import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";

const CustomStages = () => {
  return (
    <Grid container sx={design.Container}>
      <CustomText
        color="#782A9F"
        fontWeight={500}
        fontFamily="Nunito"
        textAlign="center"
        width="100%"
        sx={design.TextPrinc}
      >
        Fases del proyecto
      </CustomText>
      <CustomText
        color="#162E84"
        fontWeight={700}
        fontFamily="Nunito"
        textAlign="center"
        width="100%"
        sx={design.TextProyect}
      >
        Un proyecto que crece por etapas
      </CustomText>
      <CustomText
        color="#000000"
        fontWeight={600}
        fontFamily="Nunito"
        textAlign="center"
        width="100%"
        sx={design.TextDescription}
      >
        Cada etapa representa un paso firme hacia la construcción del hospital
        integral que nuestra comunidad necesita
      </CustomText>
      <Grid container sx={design.CardsContainer}>
        <Grid size={design.grid0} />
        {data.map((doc, idx) => (
          <Grid key={idx} size={design.grid}>
            <Box sx={design.Card}>
              <Box sx={design.ImageContainer}>
                <ImageLoader
                  src={doc.imagen}
                  alt={doc.titulo}
                  width="100%"
                  height="100%"
                />
                <Box sx={design.sombra} />
                <Box sx={design.circle(doc)} />
                <Box sx={design.Phase(doc)}>
                  <CustomText
                    color="#FFFFFF"
                    fontWeight={500}
                    fontFamily="Nunito"
                    sx={design.PhaseText}
                  >
                    Fase {idx + 1}
                  </CustomText>
                </Box>
              </Box>
              <Box sx={design.Content}>
                <CustomText
                  color={doc.color}
                  fontWeight={700}
                  fontFamily="Nunito"
                  textAlign="left"
                  width="100%"
                  sx={design.CardTitle}
                >
                  {doc.titulo}
                </CustomText>
                <CustomText
                  color="#3A3A3A"
                  fontWeight={400}
                  fontFamily="Nunito"
                  textAlign="left"
                  width="100%"
                  sx={design.BulletText}
                >
                  {doc.description}
                </CustomText>
                <Box sx={design.Bullets}>
                  {doc.bull.map((bullet, bulletIndex) => (
                    <Box key={bulletIndex} sx={design.Bullet}>
                      <Box sx={design.BulletPoint} />
                      <CustomText
                        color="#3A3A3A"
                        fontWeight={400}
                        fontFamily="Nunito"
                        sx={design.BulletText}
                      >
                        {bullet}
                      </CustomText>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
        <Grid size={design.grid0} />
      </Grid>
    </Grid>
  );
};

export default CustomStages;

const design = {
  Container: {
    my: { xs: 1, md: 2 },
  },
  TextPrinc: {
    fontSize: {
      xs: 19,
      sm: 24,
      md: 26,
      lg: 17,
    },
    lineHeight: 1.2,
    mt: 2,
  },
  TextProyect: {
    fontSize: {
      xs: 32,
      sm: 42,
      md: 52,
      lg: 55,
    },
    lineHeight: 1.1,
    mb: 2,
  },
  TextDescription: {
    fontSize: {
      xs: 19,
      sm: 17,
      md: 18,
      lg: 19,
    },
  },
  CardsContainer: {
    width: "100%",
    mt: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    mb: 5,
  },
  Card: {
    width: "97%",
    height: { xs: "auto", md: 480 },
    mb: { xs: 3, md: "auto" },
    borderRadius: "20px",
    overflow: "hidden",
    backgroundColor: "#E9E7EA",
    position: "relative",
    boxShadow: "0 3px 10px rgba(0,0,0,.08)",
    transition: "all .3s ease",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 12px 30px rgba(0,0,0,.14)",
    },
  },
  ImageContainer: {
    position: "relative",
    width: "100%",
    height: {
      xs: 200,
      sm: 200,
      md: 240,
    },
    overflow: "hidden",
    flexShrink: 0,
  },
  sombra: {
    position: "absolute",
    inset: 0,
    background: "rgba(255, 255, 255, 0.28)",
    zIndex: 1,
    pointerEvents: "none",
  },
  Phase: (doc) => ({
    position: "absolute",
    top: { xs: 25, md: 32 },
    left: { xs: 25, md: 35 },
    borderRadius: "30px",
    backgroundColor: doc.color,
    zIndex: 3,
  }),
  PhaseText: {
    fontSize: {
      xs: 15,
      md: 14,
    },
    lineHeight: 1,
    whiteSpace: "nowrap",
    my: 1,
    mx: 3,
  },
  Content: {
    pl: { xs: 1.5, sm: 1.5, md: 1.5 },
    pt: { xs: 1, md: 1 },
    pb: { xs: 3, md: 1 },
  },
  CardTitle: {
    fontSize: {
      xs: 27,
      sm: 29,
      md: 25,
    },
    lineHeight: 1.15,
    mb: 2,
    position: "relative",
    "&::after": {
      content: '""',
      display: "block",
      width: {
        xs: "95px",
        md: "120px",
      },
      height: "4px",
      backgroundColor: "currentColor",
      borderRadius: "10px",
    },
  },
  Bullets: {
    display: "flex",
    flexDirection: "column",
    mt: 2,
  },
  Bullet: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    width: "100%",
  },
  BulletPoint: (doc) => ({
    width: 7,
    height: 7,
    minWidth: 7,
    borderRadius: "50%",
    mt: "9px",
    backgroundColor: doc.color,
  }),
  BulletText: {
    fontSize: {
      xs: 16,
      sm: 17,
      md: 17,
    },
    lineHeight: 1.3,
  },
  circle: (doc) => ({
    position: "absolute",
    inset: 0,
    zIndex: 2,
    pointerEvents: "none",
    background: `
      radial-gradient(
        circle at 82% 8%,
        ${doc.color}CC 0%,
        ${doc.color}99 18%,
        ${doc.color}30 32%,
        ${doc.color}22 48%,
        transparent 68%
      )
    `,
  }),
  grid0: { xs: 0.5, sm: 0, lg: 0 },
  grid: { xs: 11, sm: 6, lg: 3 },
};

const data = [
  {
    titulo: "El Inicio",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/el_inicio_del_proyecto_MEDAM.png",
    color: "#489E4D",
    description: "Proyecto médico hospitalario provisional de dos niveles",
    bull: [
      "Urgencias",
      "Consultorios",
      "Hospitalización",
      "Laboratorio Clínico",
    ],
  },

  {
    titulo: "El Crecimiento",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/el_crecimiento_del_proyecto.png",
    color: "#215DA6",
    description:
      "Crecimiento de la infraestructura e incorporación progresiva de espacios especializados",
    bull: [
      "Ampliación de servicios",
      "Mayor capacidad de atención",
      "Integración de nuevas especialidades",
    ],
  },

  {
    titulo: "El Hospital Integral",
    imagen:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/el_hospital_integral_del_proyecto.png",
    color: "#782A9F",
    description:
      "La tercer etapa completa la visión de MEDAM como un complejo hospitalario integral con todas las áreas y servicios especializados",
    bull: [
      "Incorporación de tecnología avanzada",
      "Servicios de alta especialidad",
      "Infraestructura sostenible",
    ],
  },
];
